import DownloadApp from './DownloadApp'

export default DownloadApp



// WEBPACK FOOTER //
// ./src/components/shared/elements/DownloadApp/index.js